import { render, staticRenderFns } from "./app.vue?vue&type=template&id=1fbaf0a6"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fbaf0a6')) {
      api.createRecord('1fbaf0a6', component.options)
    } else {
      api.reload('1fbaf0a6', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=1fbaf0a6", function () {
      api.rerender('1fbaf0a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/app.vue"
export default component.exports